import { useNavigate, useLocation, Outlet } from 'react-router'
import { useEffect } from 'react'
import { useAuth } from '@klear/ui/contexts/auth-context'
import Header from '@/components/Header'
import Sidebar from '@/components/Sidebar'
import { AgentConsole } from '@klear/ui/components/agent-console'
import { AgentContextProvider } from '@klear/ui/contexts/agent-context'

const AuthLayout = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user, isLoading } = useAuth()

  useEffect(() => {
    if (!isLoading && (!user || !user.hasKlearRole)) {
      navigate('/unauthorized', {
        state: { from: location },
        replace: true
      })
    }
  }, [user, isLoading, navigate, location])

  if (isLoading) {
    return null
  }

  if (!user) {
    return null
  }

  return (
    <div className="flex h-dvh flex-col overflow-hidden">
      <Header />
      <div className="flex min-h-0 flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex min-h-0 flex-1 flex-col overflow-y-auto">
          <AgentContextProvider>
            <Outlet />
            <AgentConsole />
          </AgentContextProvider>
        </main>
      </div>
    </div>
  )
}

export default AuthLayout
